var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.$emit('transition-front')}}},[_c('v-img',{staticClass:"kk-card",attrs:{"src":_vm.$vuetify.breakpoint.smAndDown
                ? require('@/assets/card/back-xs.png')
                : require('@/assets/card/back-md.png'),"cover":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }